import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, IconButton, Modal, Snackbar, TextField } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Autocomplete, FormControlLabel, Switch, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { getCategoryAction } from "../../../redux/coupon/GetCategoryRTK";
import { LinkCategoryAction } from "../../../redux/coupon/LinkCategoryRTk";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  background: "#fff",
  boxShadow: 24,
  padding: 20,
};

// schema
const schema = yup.object({ categoryname: yup.string().required() }).required();

export default function LinkCategory({
  linkCategory,
  setLinkCategory,
  propsData,
}) {
  // state
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const dispatchRTK = useDispatch();
  const getCategorySelector = useSelector((state) => state.getCategory);
  const { data: categoryData } = getCategorySelector;
  const linkCategorySelector = useSelector((state) => state.linkCategory);
  const { data, status, message, error } = linkCategorySelector;
  const [snackbarState, setSnackbarState] = useState(false)
  const [showPopularOnly, setShowPopularOnly] = useState(false);

  const filteredCategoryData = (categoryData ?? []).filter(
    (item) => !!item?.popular_category === showPopularOnly
  );

  // functions------>
  const handleClose = () => {
    setLinkCategory(false);
  };
  const linkUnlinkFunc = (data) => {
    if (showPopularOnly && (data?.position === "" || data?.position === undefined || isNaN(Number(data?.position)))) {
      setError("position", { type: "manual", message: "please fill the position" });
      return;
    }
    clearErrors("position");
    const foundCateId = filteredCategoryData?.find(
      (element) => element?.name == data?.categoryname
    );
    dispatchRTK(
      LinkCategoryAction({
        ...propsData,
        is_deleted: false,
        catId: foundCateId?._id,
        ...(showPopularOnly ? { position: Number(data?.position) } : {}),
      })
    );
    setSnackbarState(true)
  };
  const snackBarClose = () => {
    setSnackbarState(false)
    setLinkCategory(false)
  }


  // useEffect
  useEffect(() => {
    dispatchRTK(getCategoryAction(propsData));
  }, [dispatchRTK]);

  return (
    <>
      <Modal
        open={linkCategory}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box style={style}>
          <Stack
            direction="row"
            sx={{ diplay: "flex", justifyContent: "space-between" }}
          >
            <Typography variant="h5">Link</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <form onSubmit={handleSubmit(linkUnlinkFunc)}>
            <FormControlLabel
              control={
                <Switch
                  checked={showPopularOnly}
                  onChange={(e) => setShowPopularOnly(e.target.checked)}
                />
              }
              label={showPopularOnly ? "Showing Popular Categories" : "Showing Non-Popular Categories"}
            />
            {showPopularOnly && (
              <TextField
                type="number"
                label="Position"
                variant="outlined"
                fullWidth
                sx={{ mb: 2 }}
                {...register("position")}
                error={!!errors?.position?.message}
                helperText={errors?.position?.message}
              />
            )}
            <Autocomplete
              key={showPopularOnly}
              disablePortal
              options={filteredCategoryData.map((items) => items?.name)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  {...register("categoryname")}
                  error={errors?.categoryname?.message}
                  helperText={errors?.categoryname?.message}
                />
              )}
            />
            <Stack direction="row" sx={{ mt: 2 }} spacing={2}>
              <Button variant="contained" color="primary" type="submit">
                Link
              </Button>
              <Button variant="contained" color="error" onClick={handleClose}>
                Close
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>


      {/* snackbar */}
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState} autoHideDuration={1000} onClose={snackBarClose}>
        <Alert onClose={snackBarClose} severity={status == 200 ? "success" : "error"} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
